export enum RELATION_STATUS {
  spouse = 2,
  child = 1,
}

export enum ADDRESS_TYPES {
  poBox = 1,
  home = 2,
  abroad = 3,
}

export enum MARTIAL_STATUSES {
  widower = 1,
  bachelor = 2,
  divorcee = 3,
  married = 4,
}
